import { filter } from 'lodash';

export default class LayoutSectionSerializer {
  constructor(positions) {
    this.positions = positions;
  }

  serialize(section) {
    const positions = filter(this.positions, ['sectionId', section.id])
    return {
      ...section.serialize(),
      positions: positions.map(position => position.serialize())
    }
  }
}
